"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var Row_vue_1 = __importDefault(require("../Layout/Row.vue"));
var Column_vue_1 = __importDefault(require("../Layout/Column.vue"));
var ReceptionTransformateur_vue_1 = __importDefault(require("./ReceptionTransformateur.vue"));
var SourceValueTransfo_1 = __importDefault(require("../../../Transformateur/Mixins/SourceValueTransfo"));
var SourceControlIteration_1 = __importDefault(require("../../Mixins/SourceControlIteration"));
var SelectCustom_vue_1 = __importDefault(require("../Input/SelectCustom.vue"));
exports.default = vue_1.default.extend({
    props: ['name'],
    mixins: [SourceValueTransfo_1.default, SourceControlIteration_1.default],
    components: { SelectCustom: SelectCustom_vue_1.default, ReceptionTransformateur: ReceptionTransformateur_vue_1.default, HeRow: Row_vue_1.default, HeColumn: Column_vue_1.default },
    data: function () {
        return {
            currentIdx: null,
            allBcTransfos: [],
            bcTransfoId: null
        };
    },
    methods: {
        getBcTranfo: function (e) {
            this.bcTransfoId = e;
        },
    },
    mounted: function () {
        var affaireId = this.$root.$data.affaireId;
        var self = this;
        $.ajax({
            url: '/Affaires/GetAllBcTransfosByAffaireId',
            type: 'get',
            data: { affaireId: affaireId },
        }).done(function (data) {
            self.allBcTransfos = data;
        });
    },
    computed: {
        internalReadOnly: function () {
            return this.$root.$data.readOnly || this.parseValue().every(function (_) { return _.readOnly; });
        },
        transfos: function () {
            return this.parseValue().map(function (item, index) {
                var t = item || {};
                var text = item.readOnly ? "<i class=\"fa fa-check-circle-o text-success mr-1\"></i>" : "";
                if (t.nomPoste) {
                    text += "Poste: " + t.nomPoste + ", ";
                }
                text += "Type: " + t.type + ", Puissance: " + t.puissance + "kVA, TPC: " + (t.Tpc ? "Oui" : "Non");
                if (t.numSerie) {
                    text += ", Num\u00E9ro de s\u00E9rie: " + t.numSerie;
                }
                return {
                    value: index,
                    text: text
                };
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/ReceptionsTransformateur.vue
// module id = 217
// module chunks = 0